import { calcResize } from 'components/Layout/styles';
import styled from 'styled-components';
import { emailPattern } from 'utils/validators';
import { mediaBreakpointDown } from 'utils/styledCssHelpers';
import Button from 'components/Button';
import { Form } from 'react-bootstrap';

// Example of use. Delete if not needed.
export const SH1 = styled.h1`
  margin-right: 150px;
  ${mediaBreakpointDown(
    'lg',
    `
    padding-right: 0;
  `,
  )};
  font-size: ${calcResize(36, 60)};
`;

export const SDescription = styled.p.attrs(() => ({
  className: 'mt-4',
}))`
  padding-right: 150px;

  font-size: ${calcResize(13, 19)};

  ${mediaBreakpointDown(
    'lg',
    `
    padding-right: 0;
  `,
  )};
  margin-bottom: 50px;
  color: ${props =>
    props.mode ? props.mode === 'dark' && props.theme.colors.main : '#ffffff'};
`;

export const SFindOutMore = styled.div`
  padding-top: 15px;
  color: #ffffff;
  font-size: 16px;
`;

export const SInput = styled(Form.Control)`
  min-height: 50px;
  width: ${props =>
    (props.size === 'small' && '100px') ||
    (props.size === 'medium' && '210px') ||
    (props.size === 'large' && '530px')};

  padding: 10px;

  &:not(:first-child) {
    margin: 0 5px;
  }

  ${mediaBreakpointDown(
    'md',
    `
    display: block;
    width:100%;

    &:not(:first-child) {
      margin: 5px 0;
    }
  `,
  )};
`;

export const SButton = styled(Button)`
  width: 120px;
  height: 58px;
  background-color: ${props => props.theme.colors.accent};
  :hover {
    background-color: ${props => props.theme.colors.accent};
  }
`;
